import React, { useState, useEffect, useRef } from "react";

import "../my_styles/myStyles.css";
import { main_link } from "../Connection/Connection";
import useFetch from "../Fetch_Folder/useFetch";

import { FilterMatchMode, FilterService } from "primereact/api";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";
import { Toast } from "primereact/toast";

import axios from "axios";
//

import { isAdmin } from "../Connection/Connection";

import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import AddSchedule from "../Modals/AddSchedule";
import EditSchedule from "../Modals/EditSchedule";

import Spinner from "react-bootstrap/Spinner";
//
const Schedule = () => {
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  const [counter, setCounter] = useState(0);
  const history = useHistory();
  const user = JSON.parse(sessionStorage.getItem("user-data"));
  const user_id = user["encrypted_id"];

  if (!isAdmin) {
    history.push("/home");
  }

  const {
    error,
    isLoading,
    data: schedules,
  } = useFetch(`${main_link}scheduleIndex?user_id=${user_id}`, counter);

  const [filters, setFilters] = useState({
    name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    created_by_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    created_at_at: { value: null, matchMode: FilterMatchMode.CONTAINS },
    time: { value: null, matchMode: FilterMatchMode.CONTAINS },
    hours: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  const [editSchd, setEditSchd] = useState("");
  const [show, setShow] = useState(false);
  const editTemplate = (rowData) => {
    return (
      <Button
        type="button"
        icon="nav-icon fas fa-edit"
        style={{ borderRadius: "50px" }}
        onClick={() => {
          setShow(true);
          setEditSchd(rowData);
        }}
      />
    );
  };

  return (
    <>
      <Toast ref={toast} />{" "}
      <EditSchedule
        editSchd={editSchd}
        show={show}
        setShow={setShow}
        counter={counter}
        setCounter={setCounter}
      />
      <div>
        {/* Content Wrapper. Contains page content */}
        <div className="content-wrapper">
          {/* Content Header (Page header) */}
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1>Work Sechdule Page</h1>
                </div>
              </div>
            </div>
            {/* /.container-fluid */}
          </section>
          {/* Main content */}
          <section className="content">
            {/* Default box */}
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">
                  Work Sechdule{" "}
                  {isLoading && (
                    <Spinner
                      size="sm"
                      animation="border"
                      role="status"
                    ></Spinner>
                  )}
                </h3>
              </div>
              <DataTable
                value={schedules}
                sortMode="multiple"
                tableStyle={{ minWidth: "50rem" }}
                paginator
                rows={10}
                dataKey="index"
                filters={filters}
                filterDisplay="row"
                loading={isLoading}
                scrollable
                removableSort
                stripedRows
              >
                <Column
                  field="index"
                  header="ID"
                  sortable
                  filter
                  filterPlaceholder="Search by ID"
                  style={{ width: "10 %" }}
                ></Column>
                <Column
                  field="day"
                  header="Day"
                  sortable
                  filter
                  filterPlaceholder="Search by Day"
                ></Column>
                <Column
                  field="hours"
                  header="Time"
                  sortable
                  filter
                  filterPlaceholder="Search by time"
                ></Column>
                <Column
                  field="created_by_name"
                  header="Created By"
                  sortable
                  filter
                  filterPlaceholder="Search by created by"
                ></Column>
                <Column header="Edit" sortable body={editTemplate}></Column>
              </DataTable>
              {/* /.card-body */}
              {/* <div className="card-footer">Footer</div> */}
              {/* /.card-footer*/}
            </div>
            {/* /.card */}
          </section>
          {/* /.content */}
        </div>
        {/* /.content-wrapper */}
      </div>
    </>
  );
};

export default Schedule;
